import { DROPDOWN_SELECT_GLOBAL, DROPDOWN_SELECT_GLOBAL_LIMPIAR, DROPDOWN_SELECT_CM, DROPDOWN_SELECT_CM_LIMPIAR, DROPDOWN_SELECT_E, DROPDOWN_SELECT_E_LIMPIAR, DROPDOWN_SELECT_L, DROPDOWN_SELECT_L_LIMPIAR, DROPDOWN_SELECT_MI_MEDICO, DROPDOWN_SELECT_MI_MEDICO_ESP, DROPDOWN_SELECT_MI_MEDICO_LIMPIAR, DROPDOWN_SELECT_R, DROPDOWN_SELECT_R_LIMPIAR, DROPDOWN_SELECT_USER_PT, DROPDOWN_SELECT_PT_LIMPIAR, DROPDOWN_LIMPIAR } from "../../ActionTypes"

// CM == consulta medica
export const SelectUserGlobal = (paciente) => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_GLOBAL, payload: paciente });
};

// CM == consulta medica
export const LimpiarSelectGlobal = () => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_GLOBAL_LIMPIAR });
};

// CM == consulta medica
export const SelectUserCM = (paciente) => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_CM, payload: paciente });
};

// CM == consulta medica
export const LimpiarSelectCM = () => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_CM_LIMPIAR });
};

// E == estudios
export const SelectUserE = (paciente) => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_E, payload: paciente });
};

// E == estudios
export const LimpiarSelectE = () => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_E_LIMPIAR });
};

// R == receta
export const SelectUserReceta = (paciente) => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_R, payload: paciente });
};

// R == receta
export const LimpiarSelectReceta = () => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_R_LIMPIAR });
};

// L == Laboratorio
export const SelectUserL = (paciente) => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_L, payload: paciente });
};

// L == Laboratorio
export const LimpiarSelectL = () => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_L_LIMPIAR });
};

// Setea el user de próximos turnos 
export const  SetUserProximoTurno = (id) => (dispatch) => {
    dispatch({type: DROPDOWN_SELECT_USER_PT, payload: id})
} 
export const LimpiarSelectProximoTurno = () => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_PT_LIMPIAR });
};
// M == Medicos
export const SelectUserMedicos = (paciente) => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_MI_MEDICO, payload: paciente });
};
export const SelectEspecialistaMedicos = (especialista) => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_MI_MEDICO_ESP, payload: especialista });
};
// M == Medicos
export const LimpiarSelectMedicos = () => (dispatch) => {
  dispatch({ type: DROPDOWN_SELECT_MI_MEDICO_LIMPIAR });
};

export const resetDropdown = () => (dispatch) => {
  dispatch({ type: DROPDOWN_LIMPIAR });
};
